<template>
  <div>
    <b-form @submit.prevent="onSubmit" v-if="!setDone">
      <b-form-group class="required" label="Hasło">
        <b-input-group>
          <b-form-input
            v-model="password"
            autocomplete="off"
            type="password"
            :state="$v.password.$error? false : null"
            @input="$v.password.$reset()"
          />
        </b-input-group>
      </b-form-group>

      <b-form-group class="required" label="Powtórz hasło">
        <b-input-group>
          <b-form-input
            v-model="confirmPassword"
            autocomplete="off"
            type="password"
            :state="$v.confirmPassword.$error? false : null"
            @input="$v.confirmPassword.$reset()"
          />
        </b-input-group>
      </b-form-group>

      <b-form-group class="text-right">
        <b-button type="submit" variant="primary" block :disabled="saving">
          <span v-show="!saving">Ustaw hasło</span>
          <span v-show="saving">
            <b-spinner small label="Loading..."></b-spinner>
          </span>
        </b-button>
      </b-form-group>
    </b-form>
    <success v-else />
  </div>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required, sameAs } from "vuelidate/lib/validators";
import success from "./SetPasswordSuccess";

export default {
  props: ["email"],
  data() {
    return {
      password: null,
      confirmPassword: null,
      token: null,
      setDone: false,
      saving: false
    };
  },
  components: {
    success
  },
  validations: {
    password: {
      required
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs("password")
    }
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.saving = true;
        axios
          .post("/auth/setPassword", {
            username: this.email,
            password: this.password,
            confirmPassword: this.confirmPassword
          })
          .then(() => {
            this.setDone = true;
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => (this.saving = false));
      }
    },
    goto(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  &.btn-link {
    font-size: 0.75rem;
    text-decoration: none;
  }
}
</style>